<crm-multi-select
  #multiSelectComponent
  [options]="netPingDevices"
  [(selectedItems)]="_selectedNetPingDevices"
  (selectedItemsChange)="onSelect($event)"
  (panelShow)="onShowPanel()"
  (onFilter)="search($event.filter)"
  [showToggleAll]="true"
  [virtualScroll]="true"
  [virtualScrollItemSize]="35"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [label]="label"
  [disabled]="disabled"
  [appendTo]="appendTo"
  [placeholder]="placeholder"
  [itemStyleClass]="itemStyleClass"
  [showClear]="showClear">
  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-multi-select>
